<template>
    <div class="full-width">
        <q-list dense>
            <q-item
                v-for="(item, index) in group.itemList"
                :key="index"
                tag="label"
                style="overflow:hidden"
            >
                <q-item-section avatar>
                    <q-radio v-model="selected" :val="index" color="primary" />
                </q-item-section>
                <SuggestProductCard :info="item" :index="index" />
            </q-item>
            <div class="q-mb-md" v-if="group.itemList.length <= 0">
                sorry, suggest products are not available. 
            </div>
        </q-list>
    </div>
</template>

<script>
import { QList, QItem, QItemSection, QRadio } from "quasar";
const components = {
    QList,
    QItem,
    QItemSection,
    QRadio,
};
export default {
    name: "SuggestProductGroup",
    props: ["group"],
    components: {
        ...components,
        SuggestProductCard: () => import(`@/ui/pages/Cart/SuggestProductCard`),
    },
    data() {
        return {
            selected: false,
        };
    },
    methods: {
        getSelectedItem() {
            return this.group.itemList[this.selected];
        },
    },
};
</script>
